import React from 'react';
import PropTypes from 'prop-types';
import UserListContainer from '../../../../UserList/UserListContainer';

const propTypes = {
  users: PropTypes.instanceOf(Array),
  service: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

const defaultProps = {
  users: [],
};

export function UnstyledUsersTab({ users, service, id }) {
  return <UserListContainer users={users} instanceService={service} instanceId={id} />;
}

UnstyledUsersTab.propTypes = propTypes;
UnstyledUsersTab.defaultProps = defaultProps;

export default UnstyledUsersTab;
